<template>
  <!-- 意见反馈 - 新建反馈 author: zhangxiaofeng-->
  <div>
    <div class="feedback-content">
      <div class="rightSide instructions">
        <div
          class="page-bulletin"
        >感谢您使用造价云管理平台，您在使用过程中发现的任何问题或建议均可在此提交。我们会以最快的速度解决您的问题，回复您的建议。留下您的联系方式工作人员可更快联系到您，回复您的问题，任何您的私人信息都将严格保密，不会用作其他用途。
        </div>
      </div>
      <div class="line">
        <div class="leftSide">
          <em>*</em>反馈类型：
        </div>
        <div class="rightSide">
          <w-radio-group v-model="formObj.type">
            <w-radio label="bug">问题类</w-radio>
            <w-radio label="advice">建议类</w-radio>
          </w-radio-group>
          <!--<span class="problem">-->
          <!--<input type="radio" id="radio1" v-model="formObj.type" value="problem" name="typeradio"/>-->
          <!--<label for="radio1">问题类</label>-->
          <!--</span>-->
          <!--<span>-->
          <!--<input type="radio" id="radio2" v-model="formObj.type" value="advice" name="typeradio"/>-->
          <!--<label for="radio2">建议类</label>-->
          <!--</span>-->
          <span v-if="promptFtype" class="prompt_ftype">请输入反馈类型！</span>
        </div>
      </div>
      <div class="problem">
        <div class="leftSide">
          <em>*</em>向我们描述一下您的问题：
        </div>
        <div class="rightSide">
          <div class="content_wrapper">
            <w-input
              type="textarea"
              rows="8"
              placeholder="请输入内容"
              v-model="formObj.content"
              maxlength="255"
              show-word-limit
            ></w-input>
            <!--<textarea id="contentTextarea" class="textarea__inner"></textarea>-->
            <!--<div class="input-total_tips"><span :class="inputed >= canInput ? 'color-red' : ''">{{inputed}}</span>/{{canInput}}-->
            <!--</div>-->
          </div>
          <div v-if="promptFcontent" class="remind">请输入详细描述！</div>
        </div>
      </div>
      <div class="uploadImg">
        <div class="leftSide">
          <div>上传图片：</div>
          <div class="image_format">
            建议图片格式为
            <br/>JPG/JPEG/BMP/PNG
          </div>
        </div>
        <div class="imgUploader">
          <div class="file-list rightSide">
            <w-upload
              class="upload-demo"
              :action="this.uploadUrl"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              :on-change="handleChange"
              :limit="8"
              :on-exceed="handleExceed"
              :on-progress="uploadProgressImg"
              :on-success="handleAvatarSuccess"
              :on-error="uploadError"
              accept=".jpg, .jpeg, .png, .bmp, .JPG, .JPEG, .PBG, .BMP"
              :file-list="fileList"
              :headers="headers">
              <w-button slot="trigger" size="small" type="primary">选取文件</w-button>
            </w-upload>
          </div>
        </div>
      </div>
      <!--<div class="line">-->
        <!--<div class="leftSide">-->
          <!--<em>*</em>反馈模块：-->
        <!--</div>-->
        <!--<div class="rightSide feedback_module">-->
          <!--<w-checkbox-group v-model="formObj.module" size="small">-->
            <!--<w-checkbox border v-for="(todo, index) in module" :label="todo.id" >{{todo.name}}</w-checkbox>-->
          <!--</w-checkbox-group>-->
        <!--</div>-->
      <!--</div>-->
      <div class="line">
        <div class="leftSide">
          <em>*</em>反馈模块：
        </div>
        <ul class="rightSide feedback_module">
          <li
            class="border-radius-4"
            v-for="(todo, index) in module"
            @click="addClass(index)"
            v-bind:class="{ checked:index==current}"
            :key="index">
            {{todo.name}}
          </li>
        </ul>
      </div>
      <div v-if="promptFmodule" class="rightSide prompt_fmodule">请选择反馈模块！</div>
      <div class="contact">
        <div class="leftSide">
          请留下您的联系方式：
          <br/>（电话/邮箱）
        </div>
        <div class="rightSide">
          <w-input size="small" v-model="formObj.contact" type="text" style="width: 224px;"/>
        </div>
      </div>
      <div class="rightSide">
        <!--rightSide feedbackb_but-->
        <w-button size="small" type="primary" :disabled="butDisabled" :class="{disabled: butDisabled}"
                  @click="submitForm($event)">提交反馈
        </w-button>
      </div>
    </div>
  </div>
</template>
<script>
import SubmitFeedbackService from '@/assets/service/feedback'
import {getCookie} from '@/assets/utils'
// import {addEvent} from '@/assets/utils'
import {backendUrl, authorization, aecore} from '@/assets/js/config'

export default {
  name: 'FeedbackAdd',
  components: {},
  data () {
    return {
      canInput: 255,
      inputed: 0,
      uploadUrl: `${aecore}/portal/upload`,
      fileList: [],
      fileListUrl: [],
      current: -1,
      promptFtype: false,
      promptFcontent: false,
      promptFmodule: false,
      dialogVisible: false,
      dialogVisibleTwo: false,
      otherAdvice: '',
      temporaryImg: {},
      imgState: true,
      butDisabled: false,
      disabled: false,
      module: [],
      formObj: {
        type: '',
        content: '',
        attach: [],
        image: [],
        module: '',
        contact: ''
      },
      parentMsg: '',
      // headers: {
      //   Authorization: getCookie('opToken'),
      //   // "Content-type": "application/x-www-form-urlencoded"
      //   'Content-type': 'application/json'
      // },
      success: false,
      headers: {'Authorization': authorization},
      user: {}
    }
  },
  // components: {
  // "feedback-dialog": FeedbackDialog,
  // },
  // computed: {
  //   ...mapState([
  //     'loadingShow'
  //   ])
  // },
  methods: {
    // 获取栏目列表
    getCategoryList () {
      SubmitFeedbackService.getCategoryList().then(res => {
        const {code, data} = res
        const {list} = data
        if (code === 200 && Array.isArray(list)) {
          this.module = list.filter(item => item.parent)
        } else {
          this.module = []
        }
      }).catch(() => {
        this.module = []
      })
    },
    // 意见返回输入框 添加事件
    // initInputEvent() {
    //   if (!this.contentTextarea) return
    //   addEvent(this.contentTextarea, 'click focus keyup input propertychange', () => {
    //     let value = this.contentTextarea.value
    //     if (value.length > this.canInput) {
    //       value = value.substring(0, this.canInput)
    //     }
    //     this.inputed = value.length
    //     this.contentTextarea.value = value
    //     this.formObj.content = value
    //   })
    // },
    submitUpload () {
      this.$refs.upload.submit()
    },
    handleRemove (file, fileList) {
      this.fileListUrl = fileList
    },
    handlePictureCardPreview (file) {
      this.$viewImage({
        zIndex: 2001,
        images: [file.url]
      })
    },
    handleExceed (files, fileList) {
      this.$confirm({
        message: '当前限制选择 8 张图片！',
        type: 'warning',
        title: '提示',
        submit: (data) => {
          this.senForm()
        },
        submitText: '确定',
        cancelText: '取消',
        noCancelBtn: true
      })
    },
    handleChange (file, fileList) {
      this.fileList = fileList
    },
    uploadProgressImg () {
      this.imgState = false
      this.butDisabled = true
    },
    uploadError () {
      this.imgState = true
      this.butDisabled = false
    },
    handleAvatarSuccess (res, file) {
      var url = file.response.data.uri
      this.temporaryImg[file.name] = url
      this.fileListUrl.push(file.response.data)
      this.imageUrlduo = URL.createObjectURL(file.raw)
      this.imgState = true
      this.butDisabled = false
      // this.$message.success('图片上传成功');
    },
    addClass: function (index) {
      this.current = index
    },
    submitForm (event) {
      event.preventDefault()
      if (this.disabled) {
        return
      }
      if (!this.imgState) {
        // this.$message({
        // duration: 3000,
        // center: true,
        // message: '图片正在上传',
        // type: 'warning'
        // });
        return
      }
      let flag = false
      if (!this.formObj.type) {
        this.promptFtype = true
        flag = true
      } else {
        this.promptFtype = false
      }

      if (!this.formObj.content) {
        this.promptFcontent = true
        flag = true
      } else {
        this.promptFcontent = false
      }

      if (+this.current === -1) {
        this.promptFmodule = true
        flag = true
      } else {
        this.promptFmodule = false
      }
      if (flag) {
        return false
      }
      this.formObj.module = [this.module[this.current].id]
      this.formObj.attach = this.fileListUrl.map(item => {
        const {count, name, md5, uri, size, type} = item
        return {count, name, md5, uri, size, type}
      })
      this.formObj.images = this.fileListUrl.map(item => item.uri)
      let param = {
        title: '',
        type: this.formObj.type,
        content: this.formObj.content,
        attach: this.formObj.attach,
        images: this.formObj.images,
        category: this.formObj.module,
        contact: this.formObj.contact
      }
      this.disabled = true
      SubmitFeedbackService.submitBackfeed(param).then(ret => {
        this.disabled = false
        if (+ret.code === 200) {
          this.$router.push({path: '/feedback/success'})
        } else {
          this.$confirm({
            message: '失败了，请稍后重试！',
            title: '警告提示',
            submit: (data) => {
              this.senForm()
            },
            submitText: '确定',
            noCancelBtn: true
          })
        }
      }).catch((e) => {
        this.disabled = false
        if (e && e.err && e.err.message === 'Network Error') {
          this.$message.warning({
            message: '当前网络不可用，请稍后重试！'
          })
        } else {
          this.$message.error({
            message: '失败了，请稍后重试！'
          })
        }
      })
    }
  },
  mounted () {
    let userinfo = getCookie('ZJYUSERINFO')
    if (userinfo) {
      userinfo = JSON.parse(userinfo)
      this.user = userinfo
    }
    this.getCategoryList()
    // this.$nextTick(() => {
    //   this.contentTextarea = document.getElementById('contentTextarea')
    //   this.initInputEvent()
    // })
  }
}
</script>
<style lang="less" type="text/less" scoped>
  body {
    background: #f9f9f9;
  }

  .feedback-content {
    margin-left: 10px;
    padding: 20px;
    padding-bottom: 0px;
    font-size: 12px;
    line-height: 1.5;
  }

  .instructions {
    line-height: 20px;
    margin-bottom: 10px;
  }

  .page-bulletin {
    width: 91%;
  }

  .leftSide {
    float: left;
    width: 200px;
    padding: 0 10px;
    text-align: right;
  }

  .leftSide em {
    color: #f00;
    margin-right: 5px;
  }

  .rightSide {
    margin-left: 220px;
    text-align: left;
    position: relative;
  }

  .content_wrapper {
    position: relative;
    width: 90%;

    textarea {
      width: 100%;
      height: 150px;
      max-height: 175px;
      /*min-height: 50px;*/
      /*resize: vertical;*/
      padding: 5px;
      box-sizing: border-box;
    }

    .input-total_tips {
      position: absolute;
      display: inline-block;
      right: 1px;
      bottom: 1px;
      padding: 3px;
      background-color: #fff;
    }
  }

  .rightSide .remind {
    line-height: 40px;
    color: #f00;
  }

  .rightSide .problem {
    margin-right: 20px;
  }

  .rightSide label {
    vertical-align: middle;
  }

  .rightSide #radio1,
  .rightSide #radio2 {
    vertical-align: middle;
    margin-right: 2px;
  }

  .line {
    height: 40px;
    line-height: 40px;
    overflow: hidden;
    margin-bottom: 20px;
  }

  .problem {
    height: 200px;
  }

  .prompt_ftype {
    margin-left: 20px;
    vertical-align: middle;
    color: #f00;
  }

  .uploadImg {
    margin-bottom: 20px;
  }

  .uploadImg .file-list {
    margin-top: 10px;
    margin-bottom: 20px;
  }

  .uploadImg .image_format {
    color: #999;
    margin-top: 10px;
  }

  .contact {
    height: 45px;
    line-height: 20px;
    margin: 20px 0px;
  }

  .prompt_fmodule {
    color: #f00;
  }

  .feedbackb_but {
    line-height: 40px;
    margin-bottom: 50px;
  }

  .feedbackb_but button {
    width: 175px;
    height: 40px;
    font-size: 14px;
    margin-top: 15px;
    color: #fff;
    cursor: pointer;
    border: none;
    border-radius: 6px;
    background: linear-gradient(#00c8ff, #006fff);
    //background: url("~@/assets/images/submitbig_default.png")  no-repeat 100% 100%;
  }

  .feedbackb_but button:hover {
    //background: url("~@/assets/images/submitbig_hover.png")  no-repeat 100% 100%;
    background: linear-gradient(#0090ff, #0035ff);
  }

  .contact input {
    width: 200px;
    height: 25px;
    margin-top: 5px;
    padding: 0 5px;
  }

  .feedback_module {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }

  .feedback_module li {
    width: 100px;
    text-align: center;
    border: 1px solid #ccc;
    margin: 5px 20px 5px 0;
    height: 30px;
    line-height: 30px;
    cursor: pointer;
  }

  .feedback_module .checked {
    border-color: #0099ff;
    background: url("~@/assets/images/checked_module.png") no-repeat 100% 100%;
  }

  .feedback_module .module_other_advice {
    border: none;
    // padding: 5px;
  }

  .feedback_module .module_other_advice input {
    height: 28px;
    width: 200px;
    padding: 0 5px;
  }

  .hide {
    display: none;
  }

  button.disabled,
  button.disabled:hover {
    background: linear-gradient(#919191, #5c5c5c);
  }

  .success-content {
    text-align: center;

    img {
      margin: 6% auto;
    }

    .success_title {
      font-size: 20px;
      color: #333;
      font-weight: bold;
      margin: 15px 0;
    }

    .jump_feedback {
      font-size: 16px;
      color: #333;
    }

    .jump_feedback em {
      color: #2BA8FF;
      cursor: pointer;
      font-weight: bold;
    }
  }
</style>
